/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum LayoutActionTypes {
  StartLoading = '[UI] Start Loading',
  StopLoading = '[UI] Stop Loading',
  ShowMessage = '[UI] Show Message',
  ShowError = '[Layout] Show Error',
  ShowInfo = '[Layout] Show Info',
  ShowSuccess = '[Layout] Show Success',
  ShowInUseModal = '[Layout] Show In User Modal',
}

export enum TypeMessage {
  error = 'error',
  success = 'success',
  info = 'info',
  permission = 'permission',
}

export const StartLoading = createAction(LayoutActionTypes.StartLoading, props<{ message?: string }>());

export const StopLoading = createAction(LayoutActionTypes.StopLoading);

export const ShowMessage = createAction(LayoutActionTypes.ShowMessage, props<{ message: string; typeMessage: TypeMessage }>());

export const ShowError = createAction(LayoutActionTypes.ShowError, props<{ message?: string }>());
export const ShowInfo = createAction(LayoutActionTypes.ShowInfo, props<{ message?: string }>());

export const ShowSuccess = createAction(LayoutActionTypes.ShowSuccess, props<{ message?: string }>());

export const ShowInUseModal = createAction(LayoutActionTypes.ShowInUseModal);
